var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.874 19.213 9.898-4.228-8.767 9.015c-.171-1.763-.572-3.383-1.174-4.902l.042.121zm14.974-8.31c-.758-.037-1.647-.059-2.54-.059-5.79 0-11.371.894-16.613 2.553l.39-.106c1.238 1.292 2.29 2.776 3.105 4.399l.047.104c5.027-2.798 11.996-6.371 15.61-6.879v-.012zm-15.638.342.257-.075c2.268-.681 4.134-1.381 5.943-2.186l-.318.126c1.977-.783 3.684-1.774 5.217-2.978l-.045.034c1.643-1.314 2.897-3.052 3.601-5.048l.024-.079c.139-.299.253-.647.327-1.01l.005-.031c-2.517 3.432-12.487 3.792-12.487 3.792l2.351-2.156c-7.169.025-13.792 2.343-19.18 6.258l.095-.066c3.93.43 7.413 2.07 10.138 4.533l-.016-.014c1.351-.418 2.736-.716 4.087-1.093v-.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingdom);
export default __webpack_public_path__ + "static/media/pingdom.e26560b0ea1151706b51302e7432c4f3.svg";
export { ForwardRef as ReactComponent };